var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"outlined":"","min-height":"400"}},[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-img',{attrs:{"src":require('@/assets/img/page-not-found.jpg'),"contain":"","height":"400"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }